import ViewDetails from './ViewDetails'
import Compressed from './Compressed'
import Expanded from './Expanded'

ViewDetails.Compressed = Compressed
ViewDetails.Expanded = Expanded

export default ViewDetails